module.exports = __webpack_public_path__ + "img/45.5046dd95.jpg";